import { useState } from 'react';

/** "Ada Lovelace" as "AL": the tile when there is no photo to show. */
// Letters only: a bracketed or punctuated name part is not an initial.
function initials(name: string): string {
  const words = name.split(/\s+/).filter((word) => /\p{L}/u.test(word));
  const letterOf = (word: string | undefined) => word?.match(/\p{L}/u)?.[0] ?? '';
  const first = letterOf(words[0]);
  const last = words.length > 1 ? letterOf(words[words.length - 1]) : '';
  return (first + last).toUpperCase();
}

/**
 * A candidate's photo from their public LinkedIn profile, or their initials
 * where there is none or it does not load. Decorative beside the name, which
 * is always written out next to it.
 */
export function CandidateTile(props: {
  candidate: { id: string; name: string; hasPhoto: boolean } | undefined;
}): React.JSX.Element {
  const { candidate } = props;
  const [failed, setFailed] = useState(false);
  if (candidate === undefined) return <span className="candidate-tile" aria-hidden="true" />;
  if (candidate.hasPhoto && !failed) {
    return (
      <img
        className="candidate-tile candidate-tile-photo"
        src={`/talent-api/photo/${candidate.id}`}
        alt={candidate.name}
        aria-hidden="true"
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <span className="candidate-tile" aria-hidden="true">
      {initials(candidate.name)}
    </span>
  );
}
